const getters = {
  isMobile: state => state.app.isMobile,
  lang: state => state.app.lang,
  theme: state => state.app.theme,
  color: state => state.app.color,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  nickname: state => state.user.name,
  welcome: state => state.user.welcome,
  roles: state => state.user.roles,
  userInfo: state => state.user.info,
  addRouters: state => state.permission.addRouters,
  multiTab: state => state.app.multiTab,
  // custom
  contentWidth: state => state.app.contentWidth,
  layout: state => state.app.layout,
  fixedHeader: state => state.app.fixedHeader,
  fixSiderbar: state => state.app.fixSiderbar,
  autoHideHeader: state => state.app.autoHideHeader,
  colorWeak: state => state.app.weak,
  dynamicRouters: state => state.permission.dynamicRouters,
  defaultSystemType: state => state.permission.defaultSystemType,
  topNav: state => state.permission.topNav,
  currentNav: state => state.permission.currentNav,
  projectId: state => state.user.currentProject,
  userProject: state => state.user.project,
  currentProject: state => state.user.currentProject
}

export default getters
